import { render, staticRenderFns } from "./NsPopup.vue?vue&type=template&id=0db02f9b&scoped=true&"
import script from "./NsPopup.vue?vue&type=script&lang=js&"
export * from "./NsPopup.vue?vue&type=script&lang=js&"
import style0 from "./NsPopup.vue?vue&type=style&index=0&id=0db02f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db02f9b",
  null
  
)

export default component.exports